import richOrdersApi from '@/api/richOrders';

// initial state
const state = {
  all: [],
  currentOrderDetails: null,
  activeBanks: [],
};

// getters
const getters = {
  richOrders: (state) => state.all,
  currentOrderDetails: (state) => state.currentOrderDetails,
  activeBanks: (state) => state.activeBanks,
};

// actions
const actions = {
  async searchRichOrders({ commit }, searchDto) {
    try {
      const response = await richOrdersApi.searchRichOrders(searchDto);
      commit('setRichOrders', response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async lockOrder({ commit }, orderNumber) {
    try {
      const response = await richOrdersApi.lockOrder(orderNumber);
      commit('setCurrentOrderDetails', response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async unlockOrder({ commit }, orderNumber) {
    try {
      await richOrdersApi.unlockOrder(orderNumber);
      commit('clearCurrentOrderDetails');
    } catch (error) {
      throw error;
    }
  },

  async loadActiveBanks({ commit }) {
    try {
      const response = await richOrdersApi.getActivePartnerBanks();
      const activeBanks = response.data.filter((b) => b.status === 'ACTIVE');
      commit('setActiveBanks', activeBanks);
      return activeBanks;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async updateOrderStatus(_context, { orderId, status }) {
    try {
      const response = await richOrdersApi.updateOrderStatus(orderId, status);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async completeBulkOrder(_context, poolOrders) {
    try {
      const response = await richOrdersApi.completeBulkOrder(poolOrders);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async updateOrderItemIban(_context, { orderItemId, newIban }) {
    try {
      const response = await richOrdersApi.updateOrderItemIban(
        orderItemId,
        newIban
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async updateOrderItemNotes(_context, { orderItemId, notes }) {
    try {
      const response = await richOrdersApi.updateOrderItemNotes(
        orderItemId,
        notes
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getFraudOrders(_context) {
    try {
      const response = await richOrdersApi.getFraudOrders();
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async markFraudSent(_context, orderNumbers) {
    try {
      const response = await richOrdersApi.markFraudSent(orderNumbers);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async clearFraudFlag(_context, orderNumber) {
    try {
      const response = await richOrdersApi.clearFraudFlag(orderNumber);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getCompletedOrdersForExport(_context, { startDate, endDate }) {
    try {
      const response = await richOrdersApi.getCompletedOrdersForExport(
        startDate,
        endDate
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getNewOrdersBankSummary(_context, { startDate, endDate }) {
    try {
      const response = await richOrdersApi.getNewOrdersBankSummary(
        startDate,
        endDate
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getCompletedOrdersBankSummary(_context, { date }) {
    try {
      const response = await richOrdersApi.getCompletedOrdersBankSummary(date);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getEaltinOrderListExcel(_context, { date }) {
    try {
      const response = await richOrdersApi.getEaltinOrderListExcel(date);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async getAltindafirsatOrderListExcel(_context, { date }) {
    try {
      const response = await richOrdersApi.getAltindafirsatOrderListExcel(date);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

// mutations
const mutations = {
  setRichOrders(state, richOrders) {
    state.all = richOrders;
  },

  setCurrentOrderDetails(state, orderDetails) {
    state.currentOrderDetails = orderDetails;
  },

  clearCurrentOrderDetails(state) {
    state.currentOrderDetails = null;
  },

  setActiveBanks(state, banks) {
    state.activeBanks = banks;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
